import { RootState } from "api-store/store";

export const getCloudServicesData = (state: RootState) => state.cloudServices.data;
export const getCloudServicesLoading = (state: RootState) => state.cloudServices.loading;
export const getCloudServicesError = (state: RootState) => state.cloudServices.error;
export const getCloudServicesFetched = (state: RootState) => state.cloudServices.fetched;
export const getCloudServicesFetchAttempted = (state: RootState) => state.cloudServices.fetchAttempted;